<template>
  <div v-if="userHasLoaded">
    <b-dropdown
      class="btn-top-navbar"
      variant="transparent"
      toggle-class="text-decoration-none"
      button-class="p-0"
      right
      no-caret
    >
      <template v-slot:button-content>
        <span class="d-md-inline d-none mr-2">{{ user.name }}</span>
        <avatar
          inline
          color="#fff"
          :size="30"
          :username="user.name"
          :initials="getInitial(user.name)"
        ></avatar>
      </template>
      <b-dropdown-form>
        <div class="d-flex">
          <div class="mr-3">
            <avatar inline color="#fff" :size="40" :username="user.name" :initials="getInitial(user.name)"></avatar>
          </div>
          <div>
            {{user.name}}
            <br />
            <small class="text-muted">{{ user.email}}</small>
          </div>
        </div>
      </b-dropdown-form>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item-button @click=" OpenResetPasswordForm()">Alterar senha</b-dropdown-item-button>
       <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item-button @click="logout()"><i class="fas fa-sign-out-alt" /> Sair</b-dropdown-item-button>
    </b-dropdown>

    <reset-password-form ref="resetPasswordForm" />
  </div>
  <!-- CHANGE USER PASSWORD -->
</template>

<script>
import Avatar from "vue-avatar";
import ResetPasswordForm from "./../forms/ResetPasswordForm.vue";

export default {
  components: { Avatar, ResetPasswordForm },

  computed: {
    user() {
      return this.$store.state.user;
    },
    userHasLoaded() {
      return this.$store.state.userHasLoaded
    }
  },

  methods: {
    getInitial(value) {
      return value.slice(0, 1);
    },

    OpenResetPasswordForm() {
      this.$refs.resetPasswordForm.open();
    },
   
   logout() {
			axios.post(process.env.BASE_URL + "api/logout").then(response => {
	  		this.$store.dispatch("auth/loggout");
				this.$router.push("/login");
		 	});
		}
  }
};
</script>
<style>
</style>